import { styled, Typography } from '@mui/material';

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '28px',

  [theme.breakpoints.down('2xl')]: {
    gap: '20px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
  },
}));

export const Labels = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '12px',

  [theme.breakpoints.down('md')]: {
    gap: '8px',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-line',

  [theme.breakpoints.down('md')]: {
    whiteSpace: 'normal',
  },
}));

export const Text = styled(Typography)({});
